module.exports = __webpack_public_path__ + "img/znt2.0fd374cb.png";